export enum Solutions {
  MULTIBENEFITS_VR_VA = "MultiBenefícios VR e VA",
  MULTIBENEFITS_FLEXIBLE = "MultiBenefícios Flexíveis",
  EXPENSES = "Despesas",
  AWARDS = "Premiações",
}

export enum Subscriptions {
  PEOPLE_MANAGEMENT = "Gestão de Pessoas",
  HEALTH_NR1 = "Saúde e Bem-estar (NR-1)",
  HEALTH_WELLHUB = "Saúde e Bem-estar (Wellhub)",
  HEALTH_OPTUM_CONEXA = "Saúde e Bem-estar (Optum e Conexa)",
}
